import { LanguageSelector } from '@repo/ui/language-selector';
import { Navigate, Outlet, useRouteLoaderData } from 'react-router';
import type { rootLoader } from '@/root';

export const UnauthenticatedLayout = () => {
  const rootLoaderData = useRouteLoaderData<Awaited<ReturnType<typeof rootLoader>>>('root');
  if (rootLoaderData?.session?.user && rootLoaderData?.session?.isAuthenticated) {
    return <Navigate to="/o" />;
  }
  return (
    <>
      <div className="absolute end-4 top-4 z-50">
        <LanguageSelector />
      </div>
      <Outlet />
    </>
  );
};
